import Benefits from "./Products/Benefits";
import Client from "./Client";
import ImageFooter from "./ImageFooter";
import BookDemo from "./BookDemo";
import Slider from "react-slick";
import { useEffect, useRef, useState } from "react";
import { getVideos } from "../Api";
import { Helmet } from "react-helmet";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import sevenPartImg from "../assests/images/shonit/shonit 7parts.png.png";
import nrbcImg from "../assests/images/shonit/shonit nrbc.png";
import rbcImg from "../assests/images/shonit/shonit rbc.png";
import plateletImg from "../assests/images/shonit/platelet.png";
import shonitVideo from "../assests/videos/shonit v6.mp4";

const ShonitPage = () => {
  const [show, setShow] = useState(true);
  const [video, setVideo] = useState(shonitVideo);
  const [isOpen, setIsOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(-1);

  const parentRef = useRef();
  const sliderRef = useRef();
  const videoRef = useRef();

  useEffect(() => {
    setCurrentSlide(-1);
  }, []);

  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
    const getVideo = async () => {
      let data = await getVideos({ type: "Shonit" });
      setVideo(data.videos[0].url);
    };
    getVideo();

    if (window.innerWidth >= 1024) {
      gsap.registerPlugin(ScrollTrigger);
      const text = document.querySelectorAll(".resizeMe2 > *");
      const tl = gsap
        .timeline()
        .to(".resizeMe2", { width: 150, height: 150 })
        .fromTo(
          text,
          { y: 100, opacity: 0 },
          { y: 0, stagger: 0.3, opacity: 1 }
        );
      ScrollTrigger.refresh();

      ScrollTrigger.create({
        trigger: ".holdMeShonit2",
        animation: tl,
        pin: true,
        start: "center center",
        //end: '+=1500 bottom',
        scrub: 2,
        // markers:true
        invalidateOnRefresh: true,
        snap: true,
      });
    }
  }, []);

  useEffect(() => {
    if (!parentRef.current) {
      return;
    }
    if (window.innerWidth >= 991) {
      parentRef.current.addEventListener("wheel", (e) => handleScroll(e));
    }
    return () => {
      parentRef &&
        parentRef.current &&
        parentRef.current.removeEventListener("wheel", (e) => handleScroll(e));
    };
  }, [parentRef]);

  const handleScroll = (e) => {
    e.preventDefault();
    if (e.deltaY < 0) {
      sliderRef && sliderRef.current.slickPrev();
    } else {
      sliderRef && sliderRef.current.slickNext();
    }
    let scroolValue = sliderRef.current.innerSlider.track.props.currentSlide;
    setCurrentSlide(scroolValue);
  };

  let shonit_settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    centerMode: true,
    variableWidth: true,
    infinite: true,
    focusOnSelect: true,
    cssEase: "linear",
    touchMove: true,
  };

  let product_settings = {
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: false,
    swipe: true,
  };

  return (
    <>
      <Helmet>
        <title>SigTuple-Shonit</title>
      </Helmet>
      <BookDemo isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="product-area">
        <div className="container ">
          <div className="row">
            <div className="col-md-12">
              <div className="Product-text-area d-flex flex-column">
                <div className="mt-auto text-center Product-text">
                  <div className="logo_svg">
                    <svg
                      width="180"
                      height="71"
                      viewBox="0 0 259 71"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.2166 8.63519C21.8176 7.91898 22.9126 7.88817 23.5532 8.56944C25.6167 10.7637 29.7636 16.5495 36.0854 26.0326C38.5311 29.7013 40.8789 34.0593 43.1323 39.108C48.2176 50.5012 43.0643 63.8421 31.6219 68.9056C28.7232 70.1884 25.5863 70.8512 22.4141 70.8512C10.0351 70.8512 0 60.8591 0 48.5332C0 45.598 0.581496 42.6916 1.71119 39.9804C3.33201 36.0906 4.85909 32.8461 6.29615 30.2428C10.4126 22.7857 15.3866 15.583 21.2166 8.63519ZM22.4361 12.0466C17.2381 18.4023 12.7701 24.9665 9.03121 31.7397C7.65451 34.2336 6.17417 37.3788 4.59391 41.1713C3.62152 43.5049 3.12099 46.0067 3.12099 48.5332C3.12099 59.1428 11.7588 67.7436 22.4141 67.7436C25.1496 67.7436 27.8547 67.172 30.3544 66.0658C40.2216 61.6993 44.6656 50.195 40.2803 40.3701C38.0942 35.4723 35.828 31.2657 33.4851 27.7512C28.3308 20.0196 24.6304 14.7646 22.4361 12.0466Z"
                        fill="#DE1A1B"
                      />
                      <path
                        d="M14.0568 59.9987C9.66877 58.9972 6.24757 55.4896 5.376 51.0871C5.20932 50.2452 4.38874 49.6972 3.54317 49.8631C2.69761 50.0291 2.14726 50.8462 2.31394 51.6881C3.42384 57.2945 7.77204 61.7525 13.3595 63.0278C14.1995 63.2195 15.0366 62.6969 15.2292 61.8604C15.4217 61.024 14.8968 60.1905 14.0568 59.9987Z"
                        fill="#DE1A1B"
                      />
                      <path
                        d="M47.7743 13.7754C49.2184 15.9416 50.6186 18.5407 51.9714 21.5716C54.5791 27.4139 51.9365 34.255 46.069 36.8515L45.0925 37.2521L46.069 40.1751L47.3365 39.6913C54.7791 36.3977 58.1311 27.7202 54.8234 20.3095C53.4033 17.1277 51.9215 14.3772 50.3746 12.0568C44.5342 3.29585 44.4283 3.14118 42.7533 1.10085C42.5971 0.910504 42.4412 0.72456 42.2851 0.542207C41.6844 -0.159305 40.6094 -0.179777 39.9675 0.478909C37.53 2.97991 33.8254 8.40944 30.9258 13.3682L32.9174 16.1381C33.3569 15.4042 33.7303 14.7956 34.0374 14.3121C37.1198 9.45937 39.4781 6.00043 41.0739 3.97668C42.1302 5.31218 43.0491 6.6873 47.7743 13.7754Z"
                        fill="#DE1A1B"
                      />
                      <path
                        d="M246.526 9.26036V13.7918H244.96V9.26036H242.5V8H248.99V9.26036H246.526ZM257.396 13.7918V9.72404L255.244 13.7918H253.742L251.59 9.72404V13.7918H250.024V8H252.151L254.493 12.3839L256.835 8H258.953V13.7918H257.396Z"
                        fill="#DE1A1B"
                      />
                      <path
                        d="M85.9265 13.5054V17.5484H85.1274C83.3399 17.5484 82.1541 17.8703 81.5697 18.5141C80.9854 19.1579 80.6932 20.5957 80.6932 22.8275C80.6932 27.3255 80.5987 30.1668 80.4096 31.3514C80.1003 33.1884 79.5718 34.6047 78.8242 35.6004C78.0766 36.5962 76.9036 37.4803 75.3052 38.2529C77.1958 39.0426 78.5664 40.2486 79.4171 41.871C80.2679 43.4934 80.6932 46.1501 80.6932 49.8412C80.6932 53.189 80.7276 55.1804 80.7963 55.8156C80.9338 56.983 81.2819 57.7985 81.8404 58.2621C82.399 58.7256 83.4946 58.9573 85.1274 58.9573H85.9265V63.0004H84.4829C82.7986 63.0004 81.5783 62.863 80.8221 62.5884C79.7222 62.1935 78.8113 61.554 78.0895 60.6698C77.3676 59.7857 76.8993 58.6655 76.6845 57.3092C76.4696 55.953 76.3536 53.7297 76.3364 50.6395C76.3192 47.5493 76.1732 45.4119 75.8982 44.2273C75.6232 43.0427 75.0689 42.1071 74.2354 41.4204C73.4018 40.7336 72.3234 40.3731 71 40.3388V36.1412C72.3234 36.1069 73.4018 35.7507 74.2354 35.0725C75.0689 34.3944 75.6232 33.463 75.8982 32.2785C76.1732 31.0939 76.3192 29.0681 76.3364 26.201C76.3536 23.334 76.4052 21.4455 76.4911 20.5356C76.6458 19.0935 76.9337 17.9347 77.3547 17.0591C77.7758 16.1836 78.2957 15.484 78.9144 14.9603C79.5331 14.4367 80.3237 14.0376 81.2862 13.7629C81.9393 13.5912 83.0048 13.5054 84.4829 13.5054H85.9265ZM90.2913 20.2669C90.5079 20.2669 90.6162 20.3751 90.6162 20.5914C90.6162 20.7267 90.5214 20.9701 90.3319 21.3217C87.9763 25.7572 86.7985 31.3557 86.7985 38.1173C86.7985 44.987 87.9492 50.5043 90.2506 54.6694C90.4673 55.0751 90.5756 55.3456 90.5756 55.4808C90.5756 55.6701 90.4943 55.7648 90.3319 55.7648C90.1153 55.7648 89.6685 55.3321 88.9916 54.4666C87.2859 52.2488 85.8915 49.6186 84.8085 46.5759C83.7255 43.5332 83.184 40.7272 83.184 38.1578C83.184 32.6134 84.9845 27.2989 88.5855 22.2142C89.5061 20.916 90.0747 20.2669 90.2913 20.2669Z"
                        fill="#DE1A1B"
                      />
                      <path
                        d="M235.176 13.5044V17.5474H235.975C237.763 17.5474 238.948 17.8693 239.533 18.5131C240.117 19.1569 240.409 20.5947 240.409 22.8266C240.409 27.3246 240.504 30.1658 240.693 31.3504C241.002 33.1874 241.531 34.6037 242.278 35.5995C243.026 36.5952 244.199 37.4793 245.797 38.2519C243.907 39.0416 242.536 40.2477 241.685 41.87C240.835 43.4924 240.409 46.1491 240.409 49.8402C240.409 53.188 240.375 55.1794 240.306 55.8147C240.169 56.9821 239.821 57.7975 239.262 58.2611C238.704 58.7246 237.608 58.9564 235.975 58.9564H235.176V62.9994H236.62C238.304 62.9994 239.524 62.8621 240.28 62.5874C241.38 62.1925 242.291 61.553 243.013 60.6689C243.735 59.7847 244.203 58.6645 244.418 57.3083C244.633 55.952 244.749 53.7288 244.766 50.6385C244.783 47.5483 244.929 45.4109 245.204 44.2263C245.479 43.0417 246.034 42.1061 246.867 41.4194C247.701 40.7327 248.779 40.3721 250.103 40.3378V36.1403C248.779 36.1059 247.701 35.7497 246.867 35.0716C246.034 34.3934 245.479 33.4621 245.204 32.2775C244.929 31.0929 244.783 29.0671 244.766 26.2C244.749 23.333 244.697 21.4445 244.611 20.5346C244.457 19.0925 244.169 17.9337 243.748 17.0581C243.327 16.1826 242.807 15.483 242.188 14.9594C241.569 14.4357 240.779 14.0366 239.816 13.7619C239.163 13.5902 238.098 13.5044 236.62 13.5044H235.176ZM230.811 20.2659C230.595 20.2659 230.486 20.3741 230.486 20.5905C230.486 20.7257 230.581 20.9691 230.771 21.3207C233.126 25.7563 234.304 31.3547 234.304 38.1163C234.304 44.986 233.153 50.5033 230.852 54.6684C230.635 55.0741 230.527 55.3446 230.527 55.4798C230.527 55.6691 230.608 55.7638 230.771 55.7638C230.987 55.7638 231.434 55.3311 232.111 54.4656C233.817 52.2478 235.211 49.6176 236.294 46.5749C237.377 43.5322 237.919 40.7262 237.919 38.1568C237.919 32.6124 236.118 27.2979 232.517 22.2132C231.596 20.915 231.028 20.2659 230.811 20.2659Z"
                        fill="#DE1A1B"
                      />
                      <path
                        d="M111.115 34.1306C110.775 33.9651 110.326 33.7778 109.768 33.5687C109.21 33.3596 108.577 33.1615 107.871 32.9742C107.165 32.7869 106.397 32.6301 105.569 32.5037C104.74 32.3774 103.89 32.3143 103.018 32.3143C102.32 32.3143 101.725 32.336 101.232 32.3796C100.739 32.4232 100.325 32.4798 99.9893 32.5495C99.6536 32.6192 99.3876 32.6997 99.1914 32.7912C98.9951 32.8827 98.8447 32.9763 98.7401 33.0722C98.6354 33.168 98.5678 33.2638 98.5373 33.3596C98.5068 33.4555 98.4915 33.5426 98.4915 33.621C98.4915 33.8823 98.6223 34.111 98.884 34.307C99.1456 34.503 99.5031 34.6773 99.9566 34.8297C100.41 34.9822 100.938 35.1259 101.54 35.2609C102.141 35.396 102.78 35.5353 103.456 35.6791C104.132 35.8228 104.83 35.9796 105.549 36.1495C106.268 36.3194 106.966 36.5176 107.642 36.7441C108.318 36.9706 108.957 37.2341 109.558 37.5346C110.16 37.8352 110.688 38.1858 111.141 38.5866C111.595 38.9873 111.952 39.449 112.214 39.9717C112.476 40.4944 112.606 41.0911 112.606 41.7619C112.606 42.6244 112.454 43.3648 112.149 43.9834C111.843 44.6019 111.436 45.1246 110.925 45.5514C110.415 45.9783 109.824 46.3202 109.153 46.5772C108.481 46.8342 107.777 47.0324 107.04 47.1718C106.303 47.3112 105.558 47.4026 104.803 47.4462C104.049 47.4898 103.332 47.5115 102.651 47.5115C100.872 47.5115 99.2263 47.3656 97.7132 47.0738C96.2001 46.7819 94.8636 46.4182 93.7037 45.9827V41.6966C94.8985 42.3587 96.2611 42.877 97.7916 43.2516C99.3222 43.6262 100.96 43.8135 102.704 43.8135C103.733 43.8135 104.572 43.759 105.222 43.6501C105.872 43.5412 106.38 43.4019 106.746 43.232C107.112 43.0621 107.361 42.877 107.492 42.6766C107.622 42.4763 107.688 42.2846 107.688 42.1017C107.688 41.8142 107.557 41.5637 107.295 41.3503C107.034 41.1369 106.676 40.9496 106.223 40.7884C105.769 40.6272 105.242 40.4791 104.64 40.3441C104.038 40.2091 103.399 40.0741 102.723 39.939C102.047 39.804 101.352 39.6581 100.637 39.5013C99.9217 39.3445 99.2263 39.1593 98.5504 38.9459C97.8745 38.7325 97.2357 38.4842 96.6339 38.2011C96.0322 37.918 95.5046 37.5826 95.0511 37.1949C94.5976 36.8072 94.24 36.3586 93.9784 35.849C93.7168 35.3393 93.5859 34.7491 93.5859 34.0783C93.5859 33.2856 93.7255 32.6017 94.0045 32.0268C94.2836 31.4518 94.6608 30.9618 95.1361 30.5567C95.6114 30.1516 96.1608 29.8228 96.7844 29.5701C97.4079 29.3175 98.0642 29.1215 98.7531 28.9821C99.4421 28.8427 100.14 28.7469 100.846 28.6946C101.553 28.6423 102.224 28.6162 102.861 28.6162C103.558 28.6162 104.276 28.6511 105.013 28.7207C105.75 28.7904 106.476 28.8884 107.191 29.0148C107.906 29.1411 108.597 29.287 109.264 29.4525C109.931 29.618 110.548 29.7923 111.115 29.9752V34.1306ZM134.4 47.028V39.5405H122.051V47.028H117.198V29.0736H122.051V35.6072H134.4V29.0736H139.254V47.028H134.4ZM168.138 38.0639C168.138 39.6058 167.854 40.967 167.287 42.1474C166.72 43.3278 165.909 44.3144 164.854 45.1071C163.799 45.8999 162.519 46.4988 161.015 46.9039C159.51 47.309 157.821 47.5115 155.946 47.5115C154.071 47.5115 152.376 47.309 150.863 46.9039C149.35 46.4988 148.062 45.8999 146.998 45.1071C145.934 44.3144 145.114 43.3278 144.538 42.1474C143.963 40.967 143.675 39.6058 143.675 38.0639C143.675 36.5219 143.963 35.1608 144.538 33.9803C145.114 32.7999 145.934 31.8133 146.998 31.0206C148.062 30.2278 149.35 29.6289 150.863 29.2238C152.376 28.8188 154.071 28.6162 155.946 28.6162C157.821 28.6162 159.51 28.8188 161.015 29.2238C162.519 29.6289 163.799 30.2278 164.854 31.0206C165.909 31.8133 166.72 32.7999 167.287 33.9803C167.854 35.1608 168.138 36.5219 168.138 38.0639ZM163.232 38.0639C163.232 37.3931 163.125 36.7245 162.911 36.058C162.698 35.3916 162.318 34.7927 161.773 34.2613C161.228 33.7299 160.485 33.2987 159.543 32.9676C158.601 32.6366 157.402 32.4711 155.946 32.4711C154.969 32.4711 154.11 32.5473 153.368 32.6997C152.627 32.8522 151.986 33.0634 151.446 33.3335C150.905 33.6036 150.451 33.9194 150.085 34.2809C149.719 34.6424 149.427 35.0301 149.209 35.4439C148.991 35.8577 148.836 36.2889 148.744 36.7375C148.653 37.1862 148.607 37.6283 148.607 38.0639C148.607 38.5082 148.653 38.9568 148.744 39.4098C148.836 39.8628 148.991 40.2962 149.209 40.71C149.427 41.1238 149.719 41.5093 150.085 41.8665C150.451 42.2236 150.905 42.5351 151.446 42.8008C151.986 43.0665 152.627 43.2755 153.368 43.428C154.11 43.5805 154.969 43.6567 155.946 43.6567C157.402 43.6567 158.601 43.4912 159.543 43.1601C160.485 42.8291 161.228 42.3979 161.773 41.8665C162.318 41.3351 162.698 40.7361 162.911 40.0697C163.125 39.4033 163.232 38.7347 163.232 38.0639ZM189.683 47.028V36.9662C189.683 36.2954 189.626 35.6878 189.513 35.1433C189.399 34.5989 189.188 34.1328 188.878 33.7451C188.569 33.3575 188.137 33.0569 187.583 32.8435C187.029 32.63 186.316 32.5233 185.444 32.5233C184.782 32.5233 184.086 32.6126 183.358 32.7912C182.63 32.9698 181.908 33.2072 181.193 33.5034C180.478 33.7996 179.795 34.1437 179.146 34.5357C178.496 34.9277 177.918 35.3372 177.412 35.764V47.028H172.559V29.0736H177.412V31.5302C178.023 31.1818 178.673 30.8355 179.361 30.4914C180.05 30.1473 180.783 29.8358 181.559 29.5571C182.335 29.2783 183.159 29.0518 184.032 28.8776C184.904 28.7033 185.824 28.6162 186.792 28.6162C188.004 28.6162 189.088 28.7621 190.043 29.054C190.997 29.3458 191.806 29.7596 192.469 30.2954C193.132 30.8311 193.64 31.4801 193.993 32.2424C194.346 33.0047 194.523 33.8562 194.523 34.797V47.028H189.683ZM200.07 47.028V29.0736H204.923V47.028H200.07ZM220.621 32.9807V47.028H215.767V32.9807H208.141V29.0736H228.26V32.9807H220.621Z"
                        fill="#DE1A1B"
                      />
                    </svg>
                  </div>
                  <p className="mt-2 mb-4 fw_3">
                    <h2>
                      An AI application to analyse blood cell morphology{" "}
                      <br />
                      Identifies and pre-classifies WBCs, RBCs and platelets in a peripheral blood smear
                    </h2>
                  </p>
                  <button
                    className="d-block mx-auto px-4 plr-30"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(true);
                    }}
                  >
                    Book a Demo
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-10 col-md-12 mx-auto slider-pc-bg">
              <div className="Shonit-slider">
                <Slider {...shonit_settings}>
                  <div className="item">
                    <img src="assets/img/Shonit/shonit1.png" alt="" />
                  </div>
                  <div className="item">
                    <img src="assets/img/Shonit/shonit2.png" alt="" />
                  </div>
                  <div className="item">
                    <img src="assets/img/Shonit/shonit3.png" alt="" />
                  </div>
                </Slider>
              </div>
              <img
                src="assets/img/Shonit/pc.png"
                className="img-fluid pc-img"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div className="accurate-area pt-150 pb-50 mx-auto">
        <div className="container">
          <div className="row">
            <div className="col-xxl-11 col-12 mx-auto mt-3 position-relative">
              <p className="fs_18 fw_3 accurate-title-text">
                AI100 with <span className="text-color fw_6">Shonit</span> gives
                an accurate
              </p>

              <div className="accurate-grid grid-2 mt-5">
                <div className="accurate-list text-gray">
                  <div className="float-left mr-5">
                    <img src={sevenPartImg} />
                  </div>
                  <div className="float-left">
                    <h1 className="fs_40 fw_6 m-0">7-part</h1>
                    <span className="fs_20">DC</span>
                  </div>
                </div>
                <div className="accurate-list text-gray">
                  <div className="float-left mr-5">
                    <img src={nrbcImg} />
                  </div>
                  <div className="float-left">
                    <h1 className="fs_40 fw_6 m-0">NRBC</h1>
                    <span className="fs_20">Flagging</span>
                  </div>
                </div>
                <div className="accurate-list text-gray">
                  <div className="float-left mr-5">
                    <img src={rbcImg} />
                  </div>
                  <div className="float-left">
                    <h1 className="fs_40 fw_6 m-0">RBC</h1>
                    <span className="fs_20">Characterization</span>
                  </div>
                </div>
                <div className="accurate-list text-gray">
                  <div className="float-left mr-5">
                    <img src={plateletImg} />
                  </div>
                  <div className="float-left">
                    <h1 className="fs_40 fw_6 m-0">Platelet</h1>
                    <span className="fs_20">Estimation</span>
                  </div>
                </div>
              </div>

              <div className="text-center mt-150 mb-50">
                <h2 className="text-title text-color fw_7 ls_5 text-uppercase fs_20">
                  Features
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="analysis-area mx-auto">
        <div className="container ptb-80">
          <div className="analysis-slider">
            <div className="item">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <div className="analysis-text">
                    <h1 className="text-gray fw_3">
                      <strong>AI-assisted </strong> analysis
                    </h1>
                    <p className="text-gray m-0">
                      Automated WBC DC, RBC morphology, and platelet morphology
                      reporting with visual evidence
                    </p>
                  </div>
                </div>
                <div className="col-md-8 text-center">
                  <div className="analysis-img">
                    <img
                      src="assets/img/Shonit/gif/slider_01.gif"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="analysis-area mx-auto">
        <div className="container ptb-80">
          <div className="analysis-slider">
            <div className="item">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <div className="Microscopic-text">
                    <h1 className="text-gray fw_3">
                      <strong>Microscopic </strong> view
                    </h1>
                    <p className="text-gray m-0">
                      The Microscopic view enables the pathologist to virtually
                      “see” the slide as if it were under a microscope{" "}
                    </p>
                  </div>
                </div>
                <div className="col-md-8 text-center">
                  <div className="analysis-img">
                    <img
                      src="assets/img/Shonit/gif/slider_02.gif"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="steps-area steps-area2 mx-auto">
            <div className="container">
                <div className="row align-items-center steps-vh vh-100">
                    <div className="col-md-12 ">
                        <div className="steps-grid grid-3">
                            <div className="steps-list">
                                <div className="steps-text mt-4 text-white">
                                    <p className="m-0 opacity_05">01</p>
                                    <h1 className="fw_2 mt-2"><span className="fw_6">Quantified </span><br />RBC Morphology</h1>
                                    <p className="fw_2 lss_3">something never possible before</p>
                                </div>
                            </div>
                            <div className="steps-list">
                                <div className="steps-text mt-4 text-white">
                                    <p className="m-0 opacity_05">02</p>
                                    <h1 className="fw_2 mt-2"><span className="fw_6">Stain </span><br />Agnostic</h1>
                                    <p className="fw_2 lss_3">Shonit is a stain agnostic system, it is compatible with all Romanowsky stains</p>
                                </div>
                            </div>
                            <div className="steps-list">
                                <div className="steps-text mt-4 text-white">
                                    <p className="m-0 opacity_05">03</p>
                                    <h1 className="fw_2 mt-2"><span className="fw_6">Smear </span><br />Agnostic</h1>
                                    <p className="fw_2 lss_3">Shonit is compatible with both manual and automated smears</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="steps-area steps-area2 mx-auto">
            <div className="container steps-top-padding">
                <div className="row align-items-center steps-vh vh-100">
                    <div className="col-md-12 ">
                        <div className="steps-grid grid-3">
                            <div className="steps-list">
                                <div className="steps-text mt-4 text-white">
                                    <p className="m-0 opacity_05">04</p>
                                    <h1 className="fw_2 mt-2">Sample Preparation <br /><span className="fw_6">Quality Check </span></h1>
                                    <p className="fw_2 lss_3">System provides feedback on the quality of slides for each sample analysed.</p>
                                </div>
                            </div>
                            <div className="steps-list">
                                <div className="steps-text mt-4 text-white">
                                    <p className="m-0 opacity_05">05</p>
                                    <h1 className="fw_2 mt-2">High <br /> <span className="fw_6"> Throughput</span></h1>
                                    <p className="fw_2 lss_3">AI100 can scan 20 slides per hour for Blood analysis.</p>
                                </div>
                            </div>
                            <div className="steps-list">
                                <div className="steps-text mt-4 text-white">
                                    <p className="m-0 opacity_05">06</p>
                                    <h1 className="fw_2 mt-2">High Res <br /><span className="fw_6"> Images</span></h1>
                                    <p className="fw_2 lss_3">AI100 Captures images at 40x with 0.16 pixels/µm resolution.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}

      <div className="scroll-animation-area mx-auto">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 p-0">
              <div className="paddedCell">
                <div className="holdMeShonit2">
                  <div className="resizeMe2 steps-grid">
                    <div className="steps-list">
                      <div className="steps-text mt-4 text-white">
                        <p className="m-0">01</p>
                        <h2 className="fw_3">
                          <strong>Quantified </strong>
                          <br />
                          RBC Morphology
                        </h2>
                        <p>something never possible before</p>
                      </div>
                    </div>
                    <div className="steps-list">
                      <div className="steps-text mt-4 text-white">
                        <p className="m-0">02</p>
                        <h2 className="fw_3">
                          <strong>Stain </strong>
                          <br />
                          Agnostic
                        </h2>
                        <p>
                          Shonit is a stain agnostic system, it is compatible
                          with all Romanowsky stains
                        </p>
                      </div>
                    </div>
                    <div className="steps-list">
                      <div className="steps-text mt-4 text-white">
                        <p className="m-0">03</p>
                        <h2 className="fw_3">
                          <strong>Smear </strong>
                          <br />
                          Agnostic
                        </h2>
                        <p>
                          Shonit is compatible with both manual and automated
                          smears
                        </p>
                      </div>
                    </div>
                    <div className="steps-list">
                      <div className="steps-text mt-4 text-white">
                        <p className="m-0">04</p>
                        <h2 className="fw_3">
                          Sample Preparation <br />
                          <strong>Quality Check </strong>
                        </h2>
                        <p>
                          System provides feedback on the quality of slides for
                          each sample analysed.
                        </p>
                      </div>
                    </div>
                    <div className="steps-list">
                      <div className="steps-text mt-4 text-white">
                        <p className="m-0">05</p>
                        <h2 className="fw_3">
                          High
                          <br />
                          <strong>Throughput</strong>
                        </h2>
                        <p>
                          AI100 can scan 20 slides per hour for Blood analysis.
                        </p>
                      </div>
                    </div>
                    <div className="steps-list">
                      <div className="steps-text mt-4 text-white">
                        <p className="m-0">06</p>
                        <h2 className="fw_3">
                          High Res <br /> <strong>Images</strong>
                        </h2>
                        <p>
                          AI100 Captures images at 40x with 0.16 pixels/µm
                          resolution.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="work-area video-section" style={{ marginTop: "100vh" }}>
        <div className="container px-0 position-relative ">
          <video
            id="media-video"
            poster="assets/img/Shonit/slider/shonit_video_bg.png"
            src={video}
            type="video/mp4"
            ref={videoRef}
            controlsList="nodownload"
            onEnded={(e) => {
              setShow(true);
              videoRef.current.removeAttribute("controls");
            }}
          />
          {/* <source src="assets/video/video.mp4" type="video/mp4" /> */}
          {/* </video> */}
          <div className="video-text text-center">
            {/* <svg width="180" height="69" viewBox="0 0 236 69" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M220.209 1.58121V7.26617H218.245V1.58121H215.158V0H223.301V1.58121H220.209ZM233.846 7.26617V2.16293L231.146 7.26617H229.262L226.562 2.16293V7.26617H224.598V0H227.266L230.204 5.49986L233.142 0H235.8V7.26617H233.846Z" fill="#DE1A1B" />
                        <path d="M18.7264 6.90454V11.9768H17.7237C15.4813 11.9768 13.9936 12.3806 13.2605 13.1883C12.5274 13.996 12.1608 15.7998 12.1608 18.5998C12.1608 24.2429 12.0422 27.8074 11.805 29.2936C11.4169 31.5982 10.7539 33.3751 9.81597 34.6243C8.87803 35.8735 7.40646 36.9827 5.40121 37.952C7.77301 38.9427 9.49254 40.4558 10.5599 42.4912C11.6272 44.5265 12.1608 47.8596 12.1608 52.4903C12.1608 56.6903 12.2039 59.1887 12.2902 59.9856C12.4627 61.4502 12.8993 62.4733 13.6001 63.0548C14.3008 63.6364 15.6754 63.9271 17.7237 63.9271H18.7264V68.9994H16.9152C14.8021 68.9994 13.2712 68.8271 12.3225 68.4825C10.9426 67.9871 9.79981 67.1848 8.89421 66.0756C7.98861 64.9664 7.40106 63.561 7.13154 61.8595C6.86202 60.1579 6.71648 57.3688 6.69491 53.4918C6.67335 49.6149 6.49008 46.9334 6.14509 45.4473C5.8001 43.9611 5.10474 42.7873 4.05899 41.9258C3.01324 41.0643 1.66026 40.612 0 40.5689V35.3028C1.66026 35.2597 3.01324 34.8128 4.05899 33.962C5.10474 33.1112 5.8001 31.9428 6.14509 30.4567C6.49008 28.9705 6.67335 26.429 6.69491 22.8321C6.71648 19.2352 6.78116 16.866 6.88897 15.7245C7.08303 13.9152 7.44418 12.4614 7.97245 11.363C8.50071 10.2645 9.15295 9.38683 9.92917 8.72991C10.7054 8.07299 11.6972 7.57223 12.9047 7.22762C13.724 7.01223 15.0609 6.90454 16.9152 6.90454H18.7264ZM24.2022 15.3873C24.4739 15.3873 24.6098 15.523 24.6098 15.7945C24.6098 15.9641 24.4909 16.2695 24.2532 16.7106C21.2979 22.2753 19.8203 29.299 19.8203 37.7818C19.8203 46.4004 21.264 53.3222 24.1512 58.5476C24.423 59.0566 24.5589 59.3959 24.5589 59.5656C24.5589 59.8031 24.457 59.9218 24.2532 59.9218C23.9814 59.9218 23.4209 59.379 22.5717 58.2932C20.4317 55.5108 18.6824 52.211 17.3237 48.3938C15.965 44.5765 15.2856 41.0562 15.2856 37.8327C15.2856 30.8768 17.5444 24.2094 22.0622 17.8303C23.2171 16.2016 23.9305 15.3873 24.2022 15.3873Z" fill="#DE1A1B" />
                        <path d="M205.968 6.90479V11.9771H206.971C209.213 11.9771 210.701 12.3809 211.434 13.1886C212.167 13.9963 212.534 15.8001 212.534 18.6001C212.534 24.2431 212.652 27.8077 212.889 29.2938C213.277 31.5984 213.94 33.3753 214.878 34.6246C215.816 35.8738 217.288 36.983 219.293 37.9522C216.921 38.943 215.202 40.456 214.134 42.4914C213.067 44.5268 212.534 47.8598 212.534 52.4906C212.534 56.6905 212.49 59.189 212.404 59.9859C212.232 61.4505 211.795 62.4736 211.094 63.0551C210.394 63.6366 209.019 63.9274 206.971 63.9274H205.968V68.9997H207.779C209.892 68.9997 211.423 68.8273 212.372 68.4827C213.752 67.9873 214.895 67.1851 215.8 66.0758C216.706 64.9666 217.293 63.5612 217.563 61.8597C217.832 60.1582 217.978 57.369 217.999 53.4921C218.021 49.6152 218.204 46.9337 218.549 45.4475C218.894 43.9614 219.59 42.7876 220.635 41.926C221.681 41.0645 223.034 40.6122 224.694 40.5691V35.303C223.034 35.2599 221.681 34.813 220.635 33.9623C219.59 33.1115 218.894 31.943 218.549 30.4569C218.204 28.9707 218.021 26.4293 217.999 22.8323C217.978 19.2354 217.913 16.8662 217.805 15.7247C217.611 13.9155 217.25 12.4617 216.722 11.3632C216.194 10.2648 215.541 9.38708 214.765 8.73015C213.989 8.07323 212.997 7.57247 211.79 7.22786C210.97 7.01248 209.633 6.90479 207.779 6.90479H205.968ZM200.492 15.3876C200.22 15.3876 200.085 15.5233 200.085 15.7947C200.085 15.9644 200.203 16.2698 200.441 16.7109C203.396 22.2756 204.874 29.2993 204.874 37.7821C204.874 46.4006 203.43 53.3225 200.543 58.5479C200.271 59.0569 200.135 59.3962 200.135 59.5658C200.135 59.8033 200.237 59.9221 200.441 59.9221C200.713 59.9221 201.273 59.3792 202.123 58.2934C204.263 55.511 206.012 52.2113 207.371 48.394C208.729 44.5767 209.409 41.0564 209.409 37.833C209.409 30.8771 207.15 24.2097 202.632 17.8306C201.477 16.2019 200.764 15.3876 200.492 15.3876Z" fill="#DE1A1B" />
                        <path d="M50.3276 32.7825C49.9009 32.5748 49.3374 32.3398 48.6372 32.0775C47.9369 31.8152 47.1437 31.5666 46.2575 31.3316C45.3712 31.0966 44.4084 30.8999 43.369 30.7414C42.3296 30.5829 41.2629 30.5037 40.1687 30.5037C39.2935 30.5037 38.5467 30.531 37.9286 30.5857C37.3104 30.6403 36.7907 30.7114 36.3694 30.7988C35.9482 30.8862 35.6145 30.9873 35.3683 31.1021C35.1222 31.2168 34.9334 31.3343 34.8021 31.4546C34.6708 31.5748 34.586 31.695 34.5478 31.8152C34.5095 31.9354 34.4903 32.0447 34.4903 32.1431C34.4903 32.471 34.6544 32.7579 34.9827 33.0038C35.3109 33.2497 35.7595 33.4683 36.3284 33.6595C36.8974 33.8508 37.5593 34.0311 38.3142 34.2005C39.0692 34.3699 39.8706 34.5448 40.7185 34.7251C41.5665 34.9055 42.4418 35.1022 43.3444 35.3153C44.247 35.5284 45.1223 35.7771 45.9703 36.0612C46.8182 36.3454 47.6196 36.676 48.3746 37.053C49.1295 37.4301 49.7914 37.87 50.3604 38.3727C50.9293 38.8755 51.3779 39.4547 51.7061 40.1105C52.0344 40.7662 52.1985 41.5149 52.1985 42.3564C52.1985 43.4384 52.007 44.3674 51.6241 45.1434C51.2411 45.9194 50.7297 46.5751 50.0896 47.1107C49.4495 47.6462 48.7083 48.0752 47.8658 48.3976C47.0233 48.72 46.1399 48.9686 45.2153 49.1435C44.2908 49.3184 43.3553 49.4331 42.4089 49.4878C41.4625 49.5424 40.5626 49.5697 39.7092 49.5697C37.4772 49.5697 35.4121 49.3867 33.5138 49.0205C31.6155 48.6544 29.9388 48.1981 28.4836 47.6517V42.2745C29.9826 43.1051 31.6921 43.7554 33.6123 44.2253C35.5325 44.6953 37.5866 44.9303 39.7749 44.9303C41.0659 44.9303 42.119 44.862 42.9341 44.7254C43.7492 44.5887 44.3865 44.4139 44.8461 44.2008C45.3056 43.9876 45.6174 43.7554 45.7815 43.504C45.9457 43.2526 46.0277 43.0122 46.0277 42.7827C46.0277 42.422 45.8636 42.1078 45.5354 41.84C45.2071 41.5723 44.7585 41.3373 44.1896 41.1351C43.6207 40.9329 42.9587 40.7471 42.2038 40.5777C41.4488 40.4083 40.6474 40.2389 39.7995 40.0695C38.9515 39.9001 38.079 39.717 37.1818 39.5203C36.2846 39.3236 35.4121 39.0913 34.5642 38.8236C33.7162 38.5558 32.9148 38.2443 32.1599 37.8891C31.4049 37.5339 30.743 37.1132 30.174 36.6268C29.6051 36.1405 29.1565 35.5776 28.8283 34.9382C28.5001 34.2989 28.3359 33.5584 28.3359 32.7169C28.3359 31.7223 28.511 30.8644 28.8611 30.143C29.2112 29.4217 29.6844 28.807 30.2807 28.2987C30.877 27.7905 31.5663 27.378 32.3486 27.061C33.1309 26.7441 33.9542 26.4982 34.8185 26.3233C35.6829 26.1484 36.5582 26.0282 37.4444 25.9626C38.3306 25.897 39.1731 25.8643 39.9718 25.8643C40.8471 25.8643 41.747 25.908 42.6715 25.9954C43.5961 26.0828 44.5069 26.2058 45.4041 26.3643C46.3012 26.5227 47.1683 26.7058 48.0053 26.9135C48.8423 27.1211 49.6164 27.3397 50.3276 27.5692V32.7825ZM79.5403 48.9632V39.5695H64.0477V48.9632H57.959V26.438H64.0477V34.635H79.5403V26.438H85.629V48.9632H79.5403ZM121.866 37.717C121.866 39.6515 121.51 41.3591 120.799 42.8401C120.088 44.321 119.071 45.5587 117.747 46.5533C116.423 47.5478 114.817 48.2992 112.93 48.8074C111.042 49.3156 108.923 49.5697 106.57 49.5697C104.218 49.5697 102.093 49.3156 100.194 48.8074C98.2961 48.2992 96.6796 47.5478 95.3447 46.5533C94.0099 45.5587 92.9815 44.321 92.2594 42.8401C91.5372 41.3591 91.1762 39.6515 91.1762 37.717C91.1762 35.7825 91.5372 34.0748 92.2594 32.5939C92.9815 31.113 94.0099 29.8753 95.3447 28.8807C96.6796 27.8862 98.2961 27.1348 100.194 26.6266C102.093 26.1184 104.218 25.8643 106.57 25.8643C108.923 25.8643 111.042 26.1184 112.93 26.6266C114.817 27.1348 116.423 27.8862 117.747 28.8807C119.071 29.8753 120.088 31.113 120.799 32.5939C121.51 34.0748 121.866 35.7825 121.866 37.717ZM115.712 37.717C115.712 36.8754 115.578 36.0366 115.31 35.2005C115.041 34.3645 114.566 33.6131 113.882 32.9464C113.198 32.2797 112.265 31.7387 111.084 31.3234C109.902 30.9081 108.397 30.7004 106.57 30.7004C105.345 30.7004 104.267 30.7961 103.337 30.9873C102.407 31.1786 101.603 31.4436 100.925 31.7824C100.246 32.1212 99.6774 32.5174 99.2179 32.971C98.7584 33.4245 98.3918 33.9109 98.1183 34.43C97.8448 34.9492 97.6506 35.4902 97.5357 36.053C97.4208 36.6159 97.3634 37.1705 97.3634 37.717C97.3634 38.2744 97.4208 38.8372 97.5357 39.4056C97.6506 39.9739 97.8448 40.5176 98.1183 41.0367C98.3918 41.5559 98.7584 42.0395 99.2179 42.4876C99.6774 42.9357 100.246 43.3264 100.925 43.6598C101.603 43.9931 102.407 44.2554 103.337 44.4467C104.267 44.6379 105.345 44.7336 106.57 44.7336C108.397 44.7336 109.902 44.5259 111.084 44.1106C112.265 43.6953 113.198 43.1543 113.882 42.4876C114.566 41.8209 115.041 41.0695 115.31 40.2334C115.578 39.3974 115.712 38.5585 115.712 37.717ZM148.896 48.9632V36.3399C148.896 35.4984 148.825 34.7361 148.683 34.053C148.54 33.3699 148.275 32.7852 147.887 32.2988C147.498 31.8125 146.957 31.4354 146.262 31.1677C145.567 30.8999 144.673 30.766 143.579 30.766C142.747 30.766 141.875 30.878 140.961 31.1021C140.047 31.3261 139.142 31.624 138.245 31.9955C137.348 32.3671 136.492 32.7988 135.676 33.2907C134.861 33.7825 134.136 34.2961 133.502 34.8317V48.9632H127.413V26.438H133.502V29.5201C134.268 29.0829 135.083 28.6485 135.947 28.2168C136.812 27.7851 137.731 27.3943 138.704 27.0446C139.678 26.6949 140.712 26.4107 141.806 26.1921C142.9 25.9735 144.055 25.8643 145.269 25.8643C146.79 25.8643 148.149 26.0473 149.347 26.4135C150.545 26.7796 151.56 27.2987 152.392 27.9709C153.223 28.643 153.861 29.4572 154.304 30.4135C154.747 31.3699 154.968 32.4382 154.968 33.6185V48.9632H148.896ZM161.927 48.9632V26.438H168.016V48.9632H161.927ZM187.71 31.3398V48.9632H181.621V31.3398H172.053V26.438H197.294V31.3398H187.71Z" fill="#DE1A1B" />
                    </svg> */}
            <img
              src="assets/img/shonit_01.png"
              className="img-fluid"
              alt=""
            ></img>
          </div>
          <div
            id="play-pause-button"
            className={`${show ? `play-btn` : ""}`}
            onClick={(e) => {
              if (show) {
                setShow(false);
                videoRef.current.setAttribute("controls", "controls");
                videoRef.current.play();
              } else {
                setShow(true);
                videoRef.current.removeAttribute("controls");
                videoRef.current.load();
              }
            }}
          >
            {
              show ? <i className="fa fa-play" aria-hidden="true"></i> : null
              //  <i className="fa fa-pause" aria-hidden="true" style={{ marginLeft: "15px" }}></i>
            }
          </div>
        </div>
      </div>

      <Benefits />

      <Client />

      <ImageFooter />
    </>
  );
};
export default ShonitPage;
